const email = /^(?:[^<>()[\]\\.,;:\s@"]+(?:\.[^<>()[\]\\.,;:\s@"]+)*)@(?:[a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}$/;

const onHold = new RegExp('^On Hold$', 'i');

export { email, onHold };